import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconVolumeHigh, IconVolumeLow } from '../../../base/icons/svg';
import { VOLUME_SLIDER_SCALE } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        hoverContainer: {
            padding: '0 12px',
        },
        container: {
            minWidth: '180px',
            width: '100%',
            boxSizing: 'border-box',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '0px 12px',
        },
        iconVolumeLow: {
            minWidth: '18px',
            marginRight: '8px',
            position: 'relative',
            '& svg': {
                fill: 'rgba(255, 255, 255, 0.3) !important'
            },
        },
        iconVolumeHigh: {
            minWidth: '18px',
            marginLeft: '12px',
            position: 'relative',
            '& svg': {
                fill: 'rgba(255, 255, 255, 0.4) !important'
            },
        },
        sliderContainer: {
            position: 'relative',
            width: '100%',
            padding: '20px 0px 16px 0px',
        },
        slider: {
            position: 'absolute',
            width: '100%',
            top: '50%',
            transform: 'translate(0, -50%)'
        }
    };
});
const VolumeSlider = ({ initialValue, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [volumeLevel, setVolumeLevel] = useState((initialValue || 0) * VOLUME_SLIDER_SCALE);
    const [isDragging, setIsDragging] = useState(false);
    const _updateVolumeFromMouseEvent = (event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left; // x position within the slider container
        let newVolumeLevel = Math.round((x / rect.width) * VOLUME_SLIDER_SCALE);
        if (newVolumeLevel > 100) {
            newVolumeLevel = 100;
        }
        if (newVolumeLevel < 0) {
            newVolumeLevel = 0;
        }
        onChange(newVolumeLevel / VOLUME_SLIDER_SCALE);
        setVolumeLevel(newVolumeLevel);
    };
    const _onVolumeChange = useCallback((event) => {
        let newVolumeLevel = Number(event.currentTarget.value);
        if (newVolumeLevel > 100) {
            newVolumeLevel = 100;
        }
        if (newVolumeLevel < 0) {
            newVolumeLevel = 0;
        }
        onChange(newVolumeLevel / VOLUME_SLIDER_SCALE);
        setVolumeLevel(newVolumeLevel);
    }, [onChange]);
    const _onSliderContainerClick = useCallback((event) => {
        _updateVolumeFromMouseEvent(event);
    }, []);
    const _onMouseDown = useCallback((event) => {
        setIsDragging(true);
        _updateVolumeFromMouseEvent(event);
    }, []);
    const _onMouseMove = useCallback((event) => {
        if (isDragging) {
            _updateVolumeFromMouseEvent(event);
        }
    }, [isDragging]);
    useEffect(() => {
        const handleMouseUp = () => {
            setIsDragging(false);
        };
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    const _onClick = (e) => {
        e.stopPropagation();
    };
    return (React.createElement("div", { className: classes.hoverContainer },
        React.createElement("div", { "aria-label": t('volumeSlider'), className: cx('popupmenu__contents', classes.container), onClick: _onClick },
            React.createElement("span", { className: classes.iconVolumeLow },
                React.createElement(Icon, { size: 18, src: IconVolumeLow })),
            React.createElement("div", { className: classes.sliderContainer, onClick: _onSliderContainerClick, onMouseDown: _onMouseDown, onMouseMove: _onMouseMove },
                React.createElement("input", { "aria-valuemax": VOLUME_SLIDER_SCALE, "aria-valuemin": 0, "aria-valuenow": volumeLevel, className: cx('popupmenu__volume-slider', classes.slider), max: VOLUME_SLIDER_SCALE, min: 0, onChange: _onVolumeChange, style: { '--value': `${(volumeLevel / VOLUME_SLIDER_SCALE) * 100}%` }, tabIndex: 0, type: 'range', value: volumeLevel })),
            React.createElement("span", { className: classes.iconVolumeHigh },
                React.createElement(Icon, { size: 18, src: IconVolumeHigh })))));
};
export default VolumeSlider;
